import React, { useState } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [hoveredItem, setHoveredItem] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeMobileMenu, setActiveMobileMenu] = useState(null);

  // Desktop handlers
  const handleDesktopLinkClick = () => {
    setHoveredItem(null);
  };

  const navItems = ['SERVICES', 'PORTFOLIO', 'COMPANY', 'CAREERS'];

  const dropdownContent = {
    PORTFOLIO: ['Fintech', 'Greentech', 'Healthtech', 'Legaltech', 'Manufacturing', 'Proptech', 'Retail'],
    COMPANY: [
      { label: 'ABOUT US', to: '/company/about-us', active: true },
      { label: 'WHY US', to: '/company/why-us', active: false },
    ],
    CAREERS: ['Open Positions', 'Culture', 'Internships'],
  };

  // Mobile handlers
  const handleMobileMenuToggle = () => {
    setMobileOpen(!mobileOpen);
    setActiveMobileMenu(null);
  };

  const handleMobileItemClick = (item) => {
    setActiveMobileMenu(item);
  };

  const renderMobileSubmenu = () => {
    if (!activeMobileMenu) return null;

    return (
      <div className="mobile-submenu">
        <button className="mobile-back" onClick={() => setActiveMobileMenu(null)}>
          ← Back
        </button>
        
        {activeMobileMenu === 'SERVICES' && (
          <>
            <RouterLink to="/services" className="mobile-link" onClick={() => setMobileOpen(false)}>
              ALL SERVICES →
            </RouterLink>
            <div className="mobile-group">
              <h4>PRODUCT IDEATION</h4>
              <RouterLink to="/services/digital-transformation" className="mobile-link" onClick={() => setMobileOpen(false)}>DIGITAL TRANSFORMATION</RouterLink><br/>
              <RouterLink to="/services/scoping-session" className="mobile-link" onClick={() => setMobileOpen(false)}>SCOPING SESSION</RouterLink><br/>
              <RouterLink to="/services/product-design" className="mobile-link" onClick={() => setMobileOpen(false)}>PRODUCT DESIGN PROCESS</RouterLink><br/>
              <RouterLink to="/services/minimum-viable" className="mobile-link" onClick={() => setMobileOpen(false)}>MINIMUM VIABLE PRODUCT</RouterLink><br/>
            </div>
            <div className="mobile-group">
              <h4>PRODUCT DEVELOPMENT</h4>
              <RouterLink to="/services/software-development" className="mobile-link" onClick={() => setMobileOpen(false)}>SOFTWARE DEVELOPMENT</RouterLink><br/>
              <RouterLink to="/services/web-development" className="mobile-link" onClick={() => setMobileOpen(false)}>WEB DEVELOPMENT</RouterLink><br/>
              <RouterLink to="/services/mobile-development" className="mobile-link" onClick={() => setMobileOpen(false)}>MOBILE DEVELOPMENT</RouterLink><br/>
              <RouterLink to="/services/nearshore-teams" className="mobile-link" onClick={() => setMobileOpen(false)}>NEARSHORE TEAMS</RouterLink><br/>
              <RouterLink to="/services/ai-ds" className="mobile-link" onClick={() => setMobileOpen(false)}>AI & DATA SCIENCE</RouterLink><br/>
              <RouterLink to="/services/ui-ux" className="mobile-link" onClick={() => setMobileOpen(false)}>UX/UI DESIGN</RouterLink><br/>
              <RouterLink to="/services/qa" className="mobile-link" onClick={() => setMobileOpen(false)}>QUALITY ASSURANCE</RouterLink><br/>
            </div>
            <div className="mobile-group">
              <h4>PRODUCT IMPROVEMENT</h4>
              <RouterLink to="/services/digital-acceleration" className="mobile-link" onClick={() => setMobileOpen(false)}>DIGITAL ACCELERATION</RouterLink><br/>
              <RouterLink to="/services/code-audit" className="mobile-link" onClick={() => setMobileOpen(false)}>CODE AUDIT</RouterLink><br/>
              <RouterLink to="/services/ux-audit" className="mobile-link" onClick={() => setMobileOpen(false)}>UX AUDIT</RouterLink><br/>
            </div>
          </>
        )}

        {activeMobileMenu === 'PORTFOLIO' && (
          <>
            <h4>INDUSTRY HIGHLIGHTS</h4>
            {dropdownContent.PORTFOLIO.map((item, idx) => (
              <RouterLink
                key={idx}
                to={`/portfolio/${item.toLowerCase()}`}
                className="mobile-link"
                onClick={() => setMobileOpen(false)}
              >
                {item}
              </RouterLink>
            ))}
            <RouterLink to="/industries" className="mobile-link" onClick={() => setMobileOpen(false)}>
              ALL INDUSTRIES →
            </RouterLink>
          </>
        )}

        {activeMobileMenu === 'COMPANY' && (
          <>
            <h4>COMPANY</h4>
            {dropdownContent.COMPANY.map((item, idx) => (
              <RouterLink
                key={idx}
                to={item.to}
                className={`mobile-link ${item.active ? 'mobile-active' : ''}`}
                onClick={() => setMobileOpen(false)}
              >
                {item.label}
              </RouterLink>
            ))}
          </>
        )}
      </div>
    );
  };

  return (
    <div className="navbar-wrapper" onMouseLeave={() => setHoveredItem(null)}>
      <nav className={`navbar ${isHomePage ? 'transparent-navbar' : 'white-navbar'}`}>
        <div className="navbar-container">
          <div className="container">
            <div className="logo">
              <RouterLink to="/" onClick={handleDesktopLinkClick}>
                <img src="/logos/lattice-logo-new.png" alt="Logo" />
              </RouterLink>
            </div>
          </div>

          <ul className="nav-links">
            {navItems.map((item) => (
              <li
                key={item}
                className="nav-item"
                onMouseEnter={item !== 'CAREERS' ? () => setHoveredItem(item) : undefined}
              >
                {item === 'CAREERS' ? (
                  <RouterLink to="/careers" className="nav-link" onClick={handleDesktopLinkClick}>
                    {item}
                  </RouterLink>
                ) : (
                  <ScrollLink
                    to={item.toLowerCase()}
                    smooth
                    offset={-60}
                    duration={500}
                    onClick={handleDesktopLinkClick}
                    className="nav-link"
                  >
                    {item}
                    <svg
                      className="arrow-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </ScrollLink>
                )}
              </li>
            ))}
            <li>
              <RouterLink to="/contact" onClick={handleDesktopLinkClick}>
                <button className="contact-btn">Contact Us</button>
              </RouterLink>
            </li>
          </ul>

          <div className="hamburger" onClick={handleMobileMenuToggle}>
            ☰
          </div>
        </div>
      </nav>

      {/* Desktop Dropdowns */}
      <div className={`dropdown-surface ${hoveredItem ? 'open' : ''}`}>
        {hoveredItem && hoveredItem !== 'CAREERS' && (
          <div className="dropdown-content">
            {hoveredItem === 'SERVICES' ? (
              <div className="services-dropdown-grid">
                <div className="services-column">
                  <RouterLink to="/services" className="highlighted-link" onClick={handleDesktopLinkClick}>
                    ALL SERVICES →
                  </RouterLink>
                </div>
                <div className="services-column">
                  <h4>PRODUCT IDEATION</h4>
                  <ul>
                    <li><RouterLink to="/services/digital-transformation" onClick={handleDesktopLinkClick}>DIGITAL TRANSFORMATION</RouterLink></li>
                    <li><RouterLink to="/services/scoping-session" onClick={handleDesktopLinkClick}>SCOPING SESSION</RouterLink></li>
                    <li><RouterLink to="/services/product-design" onClick={handleDesktopLinkClick}>PRODUCT DESIGN PROCESS</RouterLink></li>
                    <li><RouterLink to="/services/minimum-viable" onClick={handleDesktopLinkClick}>MINIMUM VIABLE PRODUCT</RouterLink></li>
                  </ul>
                </div>
                <div className="services-column">
                  <h4>PRODUCT DEVELOPMENT</h4>
                  <ul>
                    <li><RouterLink to="/services/software-development" onClick={handleDesktopLinkClick}>SOFTWARE DEVELOPMENT</RouterLink></li>
                    <li><RouterLink to="/services/web-development" onClick={handleDesktopLinkClick}>WEB DEVELOPMENT</RouterLink></li>
                    <li><RouterLink to="/services/mobile-development" onClick={handleDesktopLinkClick}>MOBILE DEVELOPMENT</RouterLink></li>
                    <li><RouterLink to="/services/nearshore-teams" onClick={handleDesktopLinkClick}>NEARSHORE TEAMS</RouterLink></li>
                    <li><RouterLink to="/services/ai-ds" onClick={handleDesktopLinkClick}>AI & DATA SCIENCE</RouterLink></li>
                    <li><RouterLink to="/services/ui-ux" onClick={handleDesktopLinkClick}>UX/UI DESIGN</RouterLink></li>
                    <li><RouterLink to="/services/qa" onClick={handleDesktopLinkClick}>QUALITY ASSURANCE</RouterLink></li>
                  </ul>
                </div>
                <div className="services-column">
                  <h4>PRODUCT IMPROVEMENT</h4>
                  <ul>
                    <li><RouterLink to="/services/digital-acceleration" onClick={handleDesktopLinkClick}>DIGITAL ACCELERATION</RouterLink></li>
                    <li><RouterLink to="/services/code-audit" onClick={handleDesktopLinkClick}>CODE AUDIT</RouterLink></li>
                    <li><RouterLink to="/services/ux-audit" onClick={handleDesktopLinkClick}>UX AUDIT</RouterLink></li>
                  </ul>
                </div>
              </div>
            ) : hoveredItem === 'PORTFOLIO' ? (
              <div className="portfolio-dropdown">
                <h4>INDUSTRY HIGHLIGHTS</h4>
                <ul>
                  {dropdownContent.PORTFOLIO.map((item, idx) => (
                    <li key={idx}>
                      <RouterLink to={`/portfolio/${item.toLowerCase()}`} onClick={handleDesktopLinkClick}>
                        {item}
                      </RouterLink>
                    </li>
                  ))}
                </ul>
                <RouterLink to="/industries" className="highlighted-link" onClick={handleDesktopLinkClick}>
                  ALL INDUSTRIES →
                </RouterLink>
              </div>
            ) : hoveredItem === 'COMPANY' ? (
              <div className="portfolio-dropdown">
                <h4>COMPANY</h4>
                <ul>
                  {dropdownContent.COMPANY.map((item, idx) => (
                    <li key={idx}>
                      <RouterLink
                        to={item.to}
                        onClick={handleDesktopLinkClick}
                        className={item.active ? 'active-link' : ''}
                      >
                        {item.label}
                      </RouterLink>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
        )}
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="mobile-overlay">
          <button 
            className="mobile-close-btn"
            onClick={() => setMobileOpen(false)}
            aria-label="Close menu"
          >
            &times;
          </button>
          {!activeMobileMenu ? (
            <div className="mobile-main-menu">
              {navItems.map((item) => (
                item === 'CAREERS' ? (
                  <RouterLink 
                    key={item}
                    to="/careers"
                    className="mobile-menu-item"
                    onClick={() => setMobileOpen(false)}
                  >
                    {item}
                  </RouterLink>
                ) : (
                  <div
                    key={item}
                    className="mobile-menu-item"
                    onClick={() => handleMobileItemClick(item)}
                  >
                    {item}
                    <span>›</span>
                  </div>
                )
              ))}
              <RouterLink to="/contact" className="mobile-menu-item" onClick={() => setMobileOpen(false)}>
                <button className="mobile-contact-btn">Contact Us</button>
              </RouterLink>
            </div>
          ) : (
            renderMobileSubmenu()
          )}
        </div>
      )}
    </div>
  );
};

export default Navbar;
